import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClinicPatientSearchComponent } from './clinic-patient-search/clinic-patient-search.component';
import { materialModules } from '../constants';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    ClinicPatientSearchComponent
  ],
  imports: [
    CommonModule,
    PerfectScrollbarModule,
    MatProgressBarModule,
    TranslateModule.forChild(),
    materialModules
  ],
  exports: [ClinicPatientSearchComponent]
})
export class ClinicPatientSearchModule { }
